export default "__VITE_ASSET__CLSphnWn__"